import { css } from 'styled-components';
import { colors } from '../colors/colors';
import { typographyLightTheme } from './light-theme';
export const typographyDarkTheme = {
    ...typographyLightTheme,
    basic: css `
    ${typographyLightTheme.basic}
    color: ${colors.warmgrey300};
  `,
    secondary: css `
    ${typographyLightTheme.secondary}
    color: ${colors.warmgrey500};
  `,
    error: css `
    ${typographyLightTheme.error}
    color: ${colors.red500};
  `,
};
//# sourceMappingURL=dark-theme.js.map